<template>
  <v-container
    v-if="selectedPlan !== null && selectedPlan !== undefined"
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="post_add"
        :value="$t('views.reports.t4a')"
        v-if="planOptions.HasT4A"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 't4aWizard',
                  params: { planId: selectedPlan.Id },
                })
              "
              >{{ $t("views.reports.run_wizard") }}</v-btn
            >
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 't4aArchive',
                  params: { planId: selectedPlan.Id },
                })
              "
              >{{ $t("views.billingwizard.archive") }}</v-btn
            >
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="pie_chart"
        :value="$t('views.demographics.demographics')"
        v-if="planOptions.HasDemographics"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'demographics',
                  params: { planId: selectedPlan.Id },
                })
              "
              >{{ $t("views.dashboard.navigate") }}</v-btn
            >
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'demographicsArchive',
                  params: { planId: selectedPlan.Id },
                })
              "
              >{{ $t("views.billingwizard.archive") }}</v-btn
            >
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="verified_user"
        :value="$t('components.plancreationwizard.eligibility')"
        v-if="planOptions.HasDemographics"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'eligibility',
                  params: { planId: selectedPlan.Id },
                })
              "
              >{{ $t("views.dashboard.navigate") }}</v-btn
            >
            <v-menu offset-y v-if="planIdentity.HasEligibilityBank">
              <template v-slot:activator="{ on }">
                <v-btn slot="activator" color="primary" v-on="on" text>
                  {{ $t("globals.select") }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'eligibilityBankMinimumHourReport',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("views.members.minimum_hour_bank_report") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'wip',
                      // params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("views.reports.self_pay_report") }}
                  </v-list-item-title>
                </v-list-item>
                </v-list>
            </v-menu>
          </div>
        </template>
      </material-stats-card>

      <!-- <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="verified_user"
        :value="$t('components.employers.employer_details.contributions')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'wip',
                  // params: { planId: selectedPlan.Id },
                })
              "
              >{{ $t("components.getreports.get") }}</v-btn
            >
          </div>
        </template>
      </material-stats-card> -->

      <!-- <material-stats-card color="success" icon="get_app" :value="$t('views.portal.download_center')" v-if="planIdentity.MembersPortal && planIdentity.MembersPortal.IsActive && role.indexOf('Broker Plan Admin') > -1">
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="success"
              @click="$router.push({name: 'adminFiles'})"
            >{{$t('views.reports.view_&_download')}}</v-btn>
          </div>
        </template>
      </material-stats-card> -->
    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
export default {
  data() {
    return {
      commissionsCount: 3,
    };
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
  },
  methods: {},
};
</script>

<style>
.with-margin {
  margin: 10px !important;
}
</style>
